export const menuData = [
    { title: "Home", link: '/' },
    { title: "About", link: '/about' },
    { title: "Services", link: '/' },
    { title: "Gallery", link: '/gallery' },
    { title: "Contact", link: '/contact' },

];